import { Button, Card, Label } from 'components/atoms';
import { DescriptiveInputWrapper, FormInput, ViewToggleButton } from 'components/molecules';
import TopBar from 'components/organisms/top-bar/TopBar';
import { TopbarPage } from 'components/templates';
import { useComponentVisible } from 'hooks';
import { useTableColumnsVisibility } from 'hooks/useTableColumnsVisibility';
import { useTranslation } from 'react-i18next';
import { PiClipboardText, PiEye, PiPlus, PiUsers, PiVideoCamera } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import {
  useGetChannelListInfinite,
  usePostChannelById,
  usePostChannelByLink,
  useSyncAllChannels,
} from 'services/channel';
import { IChannelResponse, IChannelSyncAll } from 'services/channel/types/query';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getNodes } from 'utils/table/nodes.utils';

import { MagellanPopups } from 'components/molecules';
import { Formik } from 'formik';

import { PopupActions } from 'reactjs-popup/dist/types';

import ListWrapper from 'components/molecules/list-wrapper/ListWrapper';
import { useClientMode } from 'hooks/useClientMode';
import { useIsMobile } from 'hooks/useIsMobile';
import { useIsUserBanned } from 'hooks/useIsUserBanned';
import { useListViewById } from 'hooks/useListViewById';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

enum CHANNEL_COLUMNS {
  name,
  link,
}

const Channel = () => {
  const createChannelByLink = usePostChannelByLink();
  const createChannelById = usePostChannelById();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const addVisible = useComponentVisible<HTMLDivElement>(false);

  const columnsVisibility = useTableColumnsVisibility('Channels1', CHANNEL_COLUMNS);

  const i18nextPrefix = 'channel.list';
  const viewId = 'channel';

  const { data, isLoading, fetchNextPage, isFetchingNextPage, refetch } = useGetChannelListInfinite(
    {},
  );

  const tableData = getNodes<IChannelResponse>(data?.pages.flat());

  const buttonStyle = { justifyContent: 'start' };

  const syncChannel = useSyncAllChannels();

  const onSyncChannel = async (method: keyof IChannelSyncAll) => {
    await syncChannel.mutateAsync(
      {
        updateChannel: method === 'updateChannel',
        updateVideos: method === 'updateVideos',
        addNewVideos: method === 'addNewVideos',
      },
      {
        onSuccess: async () => {
          await refetch();
        },
      },
    );
  };

  const isMobile = useIsMobile();
  const clearPopupValues = (setFieldValue: any) => {
    setFieldValue('channelId', undefined);
    setFieldValue('link', undefined);
  };

  const createChannelByIdFuncion = async (
    channelId: string,
    actions: PopupActions,
    setFieldValue: any,
  ) => {
    await createChannelById.mutateAsync(
      { channelId },
      {
        onSuccess: async (data) => {
          await refetch();
          actions.close();
          clearPopupValues(setFieldValue);
          navigate(`${data.id}/data`);
        },
        onError: (error) => onErrorShowAllErrorsToast(error),
      },
    );
  };

  const createChannelByLinkFuncion = async (
    link: string,
    actions: PopupActions,
    setFieldValue: any,
  ) => {
    await createChannelByLink.mutateAsync(
      { link },
      {
        onSuccess: async (data) => {
          await refetch();
          actions.close();
          clearPopupValues(setFieldValue);
          navigate(`${data.id}/data`);
        },
        onError: (error) => onErrorShowAllErrorsToast(error),
      },
    );
  };

  const formikInitialValue = {
    channelId: '',
    link: '',
  };

  const clientMode = useClientMode();

  const { isBanned } = useIsUserBanned();

  const { view } = useListViewById(viewId, 'grid');

  return (
    <TopbarPage
      topbarAbsolute
      topbar={
        <TopBar
          title={t(`${i18nextPrefix}.title`)}
          path=""
          customBackItem={<div />}
          topbarContent={
            <>
              <div className="flex">
                <ViewToggleButton id={viewId} />
              </div>
              {/* {!!tableData.nodes.length && clientMode.isActive && (
                <Buttons.ChannelSync
                  variant={BUTTON_VARIANT.default}
                  lastSyncDate={new Date(0).toISOString()}
                  onSync={onSyncChannel}
                  isPending={syncChannel.isPending}
                />
              )} */}
              {!isBanned && (
                // <Formik initialValues={formikInitialValue} onSubmit={() => {}}>
                //   {({ values, setFieldValue }) => (
                //     <MagellanPopups.PopupChannelCreateForm
                //       header="channel.popup.header.byLink"
                //       onAdd={(actions: PopupActions) =>
                //         createChannelByLinkFuncion(values.link, actions, setFieldValue)
                //       }
                //       clearPopupValues={() => clearPopupValues(setFieldValue)}
                //       trigger={
                //         <Button variant={BUTTON_VARIANT.submit} onlyIcon>
                //           <Button.Icon icon={<PiPlus />} />
                //           <Button.Description description={t('button.add')} />
                //         </Button>
                //       }
                //     >
                //       <DescriptiveInputWrapper
                //         header={
                //           'Mozesz łatwo dodac dowolny kanal YouTube za pomoca adresu URL ze strony YouTube, nazwy kanału zaczynajacej sie od @ lub identyfikatora kanału '
                //         }
                //       >
                //         <FormInput.Text
                //           type="text"
                //           // label={t('channel.popup.input.byLink')}
                //           appBackground
                //           placeholder="https://www.youtube.com/@example"
                //           name="link"
                //         />
                //       </DescriptiveInputWrapper>
                //     </MagellanPopups.PopupChannelCreateForm>
                //   )}
                // </Formik>
                <Formik initialValues={formikInitialValue} onSubmit={() => {}}>
                  {({ values, setFieldValue }) => {
                    const handlePasteFromClipboard = async () => {
                      try {
                        const text = await navigator.clipboard.readText();
                        if (text) {
                          setFieldValue('link', text);
                        }
                      } catch (e) {
                        console.error('Clipboard read failed', e);
                      }
                    };

                    return (
                      <MagellanPopups.PopupChannelCreateForm
                        header="channel.popup.header"
                        onAdd={(actions: PopupActions) =>
                          createChannelByLinkFuncion(values.link, actions, setFieldValue)
                        }
                        clearPopupValues={() => clearPopupValues(setFieldValue)}
                        trigger={
                          <Button variant={BUTTON_VARIANT.submit} onlyIcon>
                            <Button.Icon icon={<PiPlus />} />
                            <Button.Description description={t('button.add')} />
                          </Button>
                        }
                      >
                        <DescriptiveInputWrapper
                          header={t('channel.popup.description')}
                        ></DescriptiveInputWrapper>
                        <div className="flex w-[350px] items-end gap-2">
                          <FormInput.Text
                            type="text"
                            appBackground
                            placeholder={t('channel.popup.placeholder')}
                            name="link"
                          />

                          <Button
                            type="button"
                            onlyIcon
                            isClear
                            onClick={handlePasteFromClipboard}
                            title={t('button.paste')}
                          >
                            <Button.Icon icon={<PiClipboardText />} />
                          </Button>
                        </div>
                      </MagellanPopups.PopupChannelCreateForm>
                    );
                  }}
                </Formik>
              )}
            </>
          }
        ></TopBar>
      }
    >
      <ListWrapper
        view={view}
        items={data?.pages.flat()}
        isLoading={isLoading}
        isFetchingNextPage={isFetchingNextPage}
        item={({
          imageLink,
          totalViews,
          totalVideoCount,
          subscribersCount,
          externalChannelId,
          name,
          id,
          link,
        }) => (
          <Card
            view={view}
            key={id}
            onClick={() => navigate(`/channel/${id}/data`)}
            image={imageLink ?? ''}
            header={name}
            description={link}
            status={
              !isMobile && view === 'list' ? (
                <div className="flex   gap-2 items-center">
                  <Label title="Subscribers" size="compact" withText style={{ minWidth: 120 }}>
                    <PiUsers />
                    {subscribersCount?.toLocaleString()}
                  </Label>
                  <Label size="compact" title="Views" withText style={{ minWidth: 135 }}>
                    <PiEye /> {totalViews?.toLocaleString()}
                  </Label>
                  <Label title="Videos" size="compact" withText style={{ minWidth: 100 }}>
                    <PiVideoCamera /> {totalVideoCount?.toLocaleString()}
                  </Label>
                </div>
              ) : undefined
            }
          />
        )}
      />
    </TopbarPage>
  );
};

export default Channel;
